import React from 'react';
import telegramService from '../services/telegram';

/**
 * Пустое состояние вкладки: один вид на все случаи.
 *
 * До этого на «Моих сохранениях» их было четыре и трёх разных видов —
 * кружок 72px синий с рамкой против 80px серого, `py-10` против `py-12`.
 * Выход был только у одной вкладки, в остальных тупик: сказали,
 * что пусто, а куда идти — нет.
 *
 * Заголовок — не `h2`: на экране уже есть `h1`, а это служебная надпись,
 * а не уровень структуры документа.
 *
 * @param {React.ComponentType} icon - Компонент иконки Phosphor
 * @param {string} title - Что произошло
 * @param {string} description - Что с этим делать
 * @param {string} [actionLabel] - Подпись кнопки выхода
 * @param {() => void} [onAction] - Куда ведёт кнопка
 */
const EmptyState = ({ icon: Icon, title, description, actionLabel, onAction }) => (
  <div className="flex flex-col items-center px-6 py-8 text-center">
    <div className="mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-theme-card-secondary">
      <Icon size={28} weight="light" className="text-theme-text-hint" />
    </div>
    <p className="mb-1 text-h3 text-theme-text-primary">{title}</p>
    <p className="text-body-sm text-theme-text-secondary">{description}</p>
    {actionLabel && onAction && (
      <button
        onClick={() => { telegramService.hapticFeedback('light'); onAction(); }}
        className="mt-4 h-10 rounded-md border-0 bg-theme-card-secondary px-[18px] text-body-sm font-semibold text-action-text transition-colors duration-fast ease-out active:scale-98"
        style={{ WebkitTapHighlightColor: 'transparent' }}
      >
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
